import React, { Component } from 'react'

class Gate extends Component {

    static propTypes = {
        side: React.PropTypes.string.isRequired,
        width: React.PropTypes.number.isRequired,
        height: React.PropTypes.number.isRequired,
        left: React.PropTypes.number.isRequired,
        top: React.PropTypes.number.isRequired,
        windowMode: React.PropTypes.bool.isRequired
    }

    constructor(props) {
        super(props);

        this.id = this.props.side + '_gate_' + this.props.windowMode;
    }

    componentDidMount() {
      this.drawCanvas();
    }

    componentDidUpdate(prevProps, prevState){
      if(this.props.width != prevProps.width) {
        this.drawCanvas();
        this.forceUpdate();
      }
    }

    drawCanvas(){
      var canvas = document.getElementById(this.id);
      var ctx = canvas.getContext("2d");

      ctx.strokeStyle="rgba(255,255,255,0.5)";
      ctx.fillStyle="rgba(255,255,255,0.5)";
      ctx.lineWidth="2";

      var ident = 1;
      var height = this.props.height - 2*ident;
      var width = this.props.width - 2*ident;
      var percent = 0.30;
      var vertical_net_step = 2;
      var gorizontal_net_step = 3;

      ctx.beginPath();
      ctx.rect(0+ident, 0+ident, width, height);
      ctx.stroke();
      ctx.closePath();


      ctx.beginPath();
      ctx.moveTo(ident + width*percent, ident);
      ctx.lineTo(ident + width*percent, ident+height);
      ctx.stroke();
      ctx.closePath();

      //сеточка
      ctx.lineWidth="1";

      for (var i = 1; vertical_net_step*i < width*(1-percent); i++) {
        ctx.beginPath();
        ctx.moveTo(ident + width*percent + vertical_net_step*i, ident);
        ctx.lineTo(ident + width*percent + vertical_net_step*i, ident+height);
        ctx.stroke();
        ctx.closePath();
      }

      for (i = 1; gorizontal_net_step*i < ident+height; i++) {
        ctx.beginPath();
        ctx.moveTo(ident + width*percent, ident + gorizontal_net_step*i);
        ctx.lineTo(ident + width, ident + gorizontal_net_step*i);
        ctx.stroke();
        ctx.closePath();
      }

      for (var i = 1; vertical_net_step*0.75*i < width*percent; i++) {
        ctx.beginPath();
        ctx.moveTo(ident + vertical_net_step*0.75*i, ident);
        ctx.lineTo(ident + vertical_net_step*0.75*i, ident+height);
        ctx.stroke();
        ctx.closePath();
      }

      for (i = 1; gorizontal_net_step*i < ident+height; i++) {
        ctx.beginPath();
        ctx.moveTo(ident, ident + gorizontal_net_step*i);
        ctx.lineTo(ident + width*percent, ident + gorizontal_net_step*i);
        ctx.stroke();
        ctx.closePath();
      }
    }

    render() {
        
      
        var style = {
          left: this.props.left - (this.props.windowMode ? 0 : 2 ) + "px",
          top: this.props.top + "px"
        }

        return (<canvas className="gate" style={style} width={this.props.width} height={this.props.height} id={this.id}>
                </canvas>)
    }
}

export default Gate



/** WEBPACK FOOTER **
 ** ./src/components/Pitch/Gate.js
 **/